import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const FIND_EMAIL_TEMPLATE_LIST_REQUEST = 'FIND_EMAIL_TEMPLATE_LIST_REQUEST'
export const FIND_EMAIL_TEMPLATE_LIST_SUCCESS = 'FIND_EMAIL_TEMPLATE_LIST_SUCCESS'
export const FIND_EMAIL_TEMPLATE_LIST_ERROR = 'FIND_EMAIL_TEMPLATE_LIST_ERROR'

export const CHANGE_PROCESS = NS + 'CHANGE_PROCESS'

export const CHANGE_LOCALE = NS + 'CHANGE_LOCALE'

export const CREATE_EMAIL_TEMPLATE_VARIANT = NS + 'CREATE_EMAIL_TEMPLATE_VARIANT'

export const FIND_EMAIL_TEMPLATE_BY_ID_REQUEST = NS + 'FIND_EMAIL_TEMPLATE_BY_ID_REQUEST'
export const FIND_EMAIL_TEMPLATE_BY_ID_SUCCESS = NS + 'FIND_EMAIL_TEMPLATE_BY_ID_SUCCESS'
export const FIND_EMAIL_TEMPLATE_BY_ID_ERROR = NS + 'FIND_EMAIL_TEMPLATE_BY_ID_ERROR'

export const CHANGE_EMAIL_TEMPLATE_VARIANT = NS + 'CHANGE_EMAIL_TEMPLATE_VARIANT'

export const SAVE_EMAIL_TEMPLATE_VARIANT_REQUEST = NS + 'SAVE_EMAIL_TEMPLATE_VARIANT_REQUEST'
export const SAVE_EMAIL_TEMPLATE_VARIANT_SUCCESS = NS + 'SAVE_EMAIL_TEMPLATE_VARIANT_SUCCESS'
export const SAVE_EMAIL_TEMPLATE_VARIANT_ERROR = NS + 'SAVE_EMAIL_TEMPLATE_VARIANT_ERROR'

export const DELETE_EMAIL_TEMPLATE_VARIANT_REQUEST = NS + 'DELETE_EMAIL_TEMPLATE_VARIANT_REQUEST'
export const DELETE_EMAIL_TEMPLATE_VARIANT_SUCCESS = NS + 'DELETE_EMAIL_TEMPLATE_VARIANT_SUCCESS'
export const DELETE_EMAIL_TEMPLATE_VARIANT_ERROR = NS + 'DELETE_EMAIL_TEMPLATE_VARIANT_ERROR'

export const GET_PROCESS_MACRO_LIST_REQUEST = NS + 'GET_PROCESS_MACRO_LIST_REQUEST'
export const GET_PROCESS_MACRO_LIST_SUCCESS = NS + 'GET_PROCESS_MACRO_LIST_SUCCESS'
export const GET_PROCESS_MACRO_LIST_ERROR = NS + 'GET_PROCESS_MACRO_LIST_ERROR'



// WEBPACK FOOTER //
// ./src/modules/email/state/manage/type.js